import { render, staticRenderFns } from "./AppVideoshotsForm.vue?vue&type=template&id=5f8dad4e"
import script from "./AppVideoshotsForm.vue?vue&type=script&lang=js"
export * from "./AppVideoshotsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports